import { client } from "./client";

import { Dietanamnez } from "types/Dietanamnez";
import { DietanamnezItem } from "types/DietanamnezItem";
import { UserType } from "types/UserType";

export type DietanamnezResponse = {
  key: string;

  fields: {
    custom_тип_да: {
      value: Dietanamnez["custom_тип_да"];
    };
    custom_специфические_виды_питания:
      | null
      | {
          key: string;
        }[];
    custom_фио_специалиста: string;
  };

  related: {
    count: number;
    list: {
      id: string;
      list: {
        key: string;
        fields: {
          custom_блюдо: {
            key: string;
          };
          custom_добавить_исключить: {
            value: number;
          };
          custom_количество: number;
          custom_частота_употребления: {
            key: string;
          };
        };
      }[];
    }[];
  };
};

export async function getDietanamnez(dietanamnezKey: string, token: string) {
  const { data } = await client.get<DietanamnezResponse>(
    `/${dietanamnezKey}/json/v2`,
    {
      headers: {
        token,
        view: "with_staff_name",
        limit: 10000,
      },
    }
  );

  return {
    dietanamnez: {
      key: data.key,
      custom_фио_специалиста: data.fields.custom_фио_специалиста,
      custom_специфические_виды_питания: (
        data.fields.custom_специфические_виды_питания || []
      ).map((item) => item.key),
      custom_тип_да: data.fields.custom_тип_да.value,
    },
    dietanamnezItems: data.related.list
      .map((item) =>
        item.list.map(({ key, fields }) => ({
          key,
          custom_количество: fields.custom_количество,
          custom_блюдо: fields.custom_блюдо.key,
          custom_частота_употребления: fields.custom_частота_употребления.key,
          custom_добавить_исключить: fields.custom_добавить_исключить.value,
        }))
      )
      .reduce((acc, items) => {
        acc.push(...items);
        return acc;
      }, [] as (DietanamnezItem & { key: string })[]),
  };
}

export async function updateDietanamnez(
  dietanamnezKey: string,
  token: string,
  values: Partial<Dietanamnez>
) {
  const { data } = await client.put<DietanamnezResponse>(
    `/${dietanamnezKey}/json/v2`,
    { data: values },
    {
      headers: {
        token,
      },
    }
  );

  return data;
}

export async function addDietanamnezItem(
  dietanamnezKey: string,
  token: string,
  values: DietanamnezItem
) {
  const { data } = await client.post<DietanamnezResponse>(
    `/${process.env.REACT_APP_API_KEY}t65r/json/v2`,
    {
      data: {
        ___parent: dietanamnezKey,
        ...values,
      },
    },
    {
      headers: {
        token,
      },
    }
  );

  return data;
}

export async function updateDietanamnezItem(
  key: string,
  token: string,
  values: Partial<DietanamnezItem>
) {
  const { data } = await client.put<DietanamnezResponse>(
    `/${key}/json/v2`,
    { data: values },
    {
      headers: {
        token,
      },
    }
  );

  return data;
}

export async function removeDietanamnezItem(key: string, token: string) {
  const { data } = await client.delete<DietanamnezResponse>(`/${key}/json/v2`, {
    headers: {
      token,
    },
  });

  return data;
}

export async function finishDietanamnez(
  dietanamnezKey: string,
  userType: UserType,
  token: string
) {
  if (userType === UserType.PRO) {
    await updateDietanamnez(dietanamnezKey, token, {
      custom_дата_назначения: new Date().toISOString(),
    });
  }

  await client.post(
    `/${process.env.REACT_APP_API_KEY}t179r/json/v2`,
    {
      parameters: {
        da: dietanamnezKey,
        send_mail: true,
      },
    },
    {
      headers: {
        token,
        Function: "selftestFinish",
      },
    }
  );
}
